<template>
  <div>
    <horizontal-selling-list
      v-if="product.crossSelling && product.crossSelling.length"
      :list="product.crossSelling"
      title="Shopper la collection"
    />
    <div id="product-body" class="sky__product-body" style="margin-top: 100px;">
      <div class="big-container mx-auto">
        <ul class="w-full hidden lg:flex text-sm" :style="descriptionPicture ? 'margin-bottom: 110px;' : 'margin-bottom: 50px'">
          <li v-if="descriptionPicture" class="px-5 text-sky_secondary">
            <a
              href="#en-un-coup-doeil"
              @click.prevent="scrollTo('#en-un-coup-doeil')"
            >
              En un coup d'oeil
            </a>
          </li>
          <li v-if="product.properties.description" class="px-5">
            <a
              href="#description"
              @click.prevent="scrollTo('#description')"
            >
              Description
            </a>
          </li>
          <li class="px-5">
            <a
              href="#caracteristiques"
              @click.prevent="scrollTo('#caracteristiques')"
            >
              Caractéristiques
            </a>
          </li>
          <li v-if="product.properties.notice" class="px-5">
            <a
              href="#notice"
              @click.prevent="scrollTo('#notice')"
            >
              Notice
            </a>
          </li>
          <li class="px-5">
            <a
              href="#reviews"
              @click.prevent="scrollTo('#reviews')"
            >
              Avis Client
            </a>
          </li>
        </ul>
      </div>
      <div v-if="product.properties.description" id="product-description" class="bg-sky_grey_darker py-10 mb-10 px-4">
        <div class="big-container mx-auto">
          <div v-if="descriptionPicture" id="en-un-coup-doeil" style="margin-top: -130px;" class="mb-8 hidden md:block">
            <img
              class="mx-auto max-w-full"
              :src="descriptionPicture"
              alt="Lanterne Volante"
              loading="lazy"
              width="1000"
              height="347"
            >
          </div>
          <div v-if="descriptionPictureMobile" style="margin-top: -100px;" class="mb-8 md:hidden">
            <img
              class="mx-auto"
              :src="descriptionPictureMobile"
              alt="Lanterne Volante"
              width="500"
              height="675"
              loading="lazy"
            >
          </div>
          <div v-if="product.properties.description">
            <h2 id="description" class="text-2xl font-bold mb-6">
              Description détaillée
            </h2>
            <div class="sky__product-description" v-html="product.properties.description" />
          </div>
        </div>
      </div>
      <div v-if="videoUrl" class="container mx-auto px-4 mb-16">
        <h2 class="text-2xl font-bold mb-6">
          Vidéo
        </h2>
        <div class="w-full md:w-1/2">
          <iframe
            style="width: 100%"
            width="560"
            height="415"
            :src="videoUrl"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          />
        </div>
      </div>
      <div id="caracteristiques" class="mb-16">
        <features-table
          :product="product"
        />
      </div>
      <div id="notice" class="mb-16">
        <use-advices
          :product="product"
        />
      </div>
      <product-reviews :product="product" />
    </div>
    <horizontal-selling-list
      v-if="product.crossLinking && product.crossLinking.length"
      class="mt-8"
      :list="product.crossLinking"
      title="Produits"
      subtitle="Similaires"
    />
  </div>
</template>

<script>
import EtoilesAvis from '../../assets/icons/etoiles-avis.svg'
import HorizontalSellingList from '../reusable/HorizontalSellingList'
import UseAdvices from './UseAdvices'
import FeaturesTable from './FeaturesTable'
import ProductReviews from './ProductReviews'

export default {
  components: {
    UseAdvices,
    EtoilesAvis,
    FeaturesTable,
    ProductReviews,
    HorizontalSellingList
  },
  data () {
    return {
      tidioSkuListenerAttached: false
    }
  },
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  mounted () {
    this.pushSkuToTidio()
  },
  watch: {
    'product.sku' () {
      this.pushSkuToTidio()
    }
  },
  computed: {
    descriptionPicture () {
      return this.product.properties.descriptionPicture ? this.product.properties.descriptionPicture + '?resize=true&width=1000&format=webp' : null
    },
    descriptionPictureMobile () {
      return this.product.properties.descriptionPictureMobile ? this.product.properties.descriptionPictureMobile + '?resize=true&width=500&format=webp' : null
    },
    videoUrl () {
      if (!this.product.properties.video) {
        return null
      }
      try {
        const url = new URL(this.product.properties.video)
        const v = url?.search?.slice(1)?.match(/v=([A-Za-z0-9-]*)/)?.[1]
        return v ? `https://www.youtube.com/embed/${v}` : null
      } catch (error) {
        console.error(error)
      }
      return null
    }
  },
  methods: {
    scrollTo (id) {
      document.querySelector(id).scrollIntoView({
        behavior: 'smooth'
      })
    },
    pushSkuToTidio () {
      const sku = this.product?.sku || this.product?.properties?.sku
      if (!sku || typeof window === 'undefined') {
        return
      }

      const sendSku = () => {
        if (window.tidioChatApi && typeof window.tidioChatApi.setVisitorData === 'function') {
          try {
            console.log('SKU envoyé à Tidio', sku)
            window.tidioChatApi.setVisitorData({
              customAttributes: [
                {
                  key: 'productSku',
                  value: String(sku)
                }
              ]
            }, data => {
              console.log('SKU confirmé par Tidio', data?.customAttributes?.find?.((attr) => attr.key === 'productSku')?.value)
            })
          } catch (error) {
            console.error('Tidio SKU push failed', error)
          }
        }
      }

      if (window.tidioChatApi && typeof window.tidioChatApi.on === 'function') {
        window.tidioChatApi.on('ready', sendSku)
      } else if (!this.tidioSkuListenerAttached) {
        this.tidioSkuListenerAttached = true
        const handler = () => {
          sendSku()
          document.removeEventListener('tidioChat-ready', handler)
          this.tidioSkuListenerAttached = false
        }
        document.addEventListener('tidioChat-ready', handler)
      }
    }
  }
}
</script>

<style lang="scss">
  .sky__product-reviews-recap {
    width: 100%;
    @screen lg {
      width: 274px;
    }
  }
  .sky__product-description {
    @apply text-justify;
    p {
      @apply mb-3;
    }
    a {
      @apply no-underline;
    }
    @screen lg {
      column-count: 2;
      column-gap: 50px;
    }
    .block-link {
      @apply tracking-widest text-sm my-2 font-bold;
      text-transform: uppercase;
      display: flex;
      position: relative;
      padding-right: 23px;
      &:after {
        @apply ml-1;
        content: '';
        display: block;
        width: 17px;
        height: 17px;
        // background: red;
        // position: absolute;
        right: 0;
        top: -2px;
        bottom: 0;
        background-image: url(../../assets/icons/nav-arrow-right-secondary.svg?img);
        background-size: 13px;
        background-position: right;
        background-repeat: no-repeat;
      }
    }
  }
</style>
